import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { RouterLink } from '@angular/router';

/**
 * Botão "Voltar" padronizado. Renderiza `<a [routerLink]>` quando `routerLink`
 * está definido, ou `<button>` que emite `back` quando não está.
 *
 * @example
 * // Com routerLink
 * <app-back-button routerLink="/campanhas" />
 *
 * // Com evento
 * <app-back-button (back)="voltar()" label="Voltar para perfis" />
 */
@Component({
  selector: 'app-back-button',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  templateUrl: './back-button.component.html',
  styleUrl: './back-button.component.scss',
})
export class BackButtonComponent {
  /** Texto do botão. Padrão: "Voltar". */
  readonly label = input<string>('Voltar');

  /**
   * Rota Angular para navegação. Quando definida, renderiza um `<a>`.
   * Quando ausente, renderiza um `<button>` que emite `back`.
   */
  readonly routerLink = input<string | undefined>(undefined);

  /** Emitido ao clicar quando `routerLink` não está definido. */
  readonly back = output<void>();
}
